import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Affichée quand l'abonnement est en past_due (paiement échoué, Stripe relance).
 * L'accès reste ouvert pendant la fenêtre de relance ; on invite à mettre à
 * jour le moyen de paiement via le portail Stripe.
 */
export default function PaymentIssueBanner() {
  const { subscription } = useAuth();
  const [loading, setLoading] = useState(false);

  if (subscription.status !== "past_due") return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("customer-portal");
      if (error) throw error;
      if (data?.url) window.open(data.url, "_blank");
    } catch {
      toast.error("Impossible d'ouvrir le portail de paiement.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-red-500/10 border-b border-red-500/20 px-4 py-2.5 flex items-center justify-center gap-3">
      <div className="flex items-center gap-2 text-sm text-red-500">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          Problème de paiement sur votre abonnement.{" "}
          <button
            onClick={openPortal}
            disabled={loading}
            className="underline font-medium hover:text-red-400 inline-flex items-center gap-1"
          >
            {loading && <Loader2 className="h-3 w-3 animate-spin" />}
            Mettre à jour ma carte
          </button>
        </span>
      </div>
    </div>
  );
}
